<app-dialog-header>
    <app-dialog-title *ngIf="shift">
        {{ shift.presenter.when }}
    </app-dialog-title>

    <app-dialog-subtitle *ngIf="shift">
        Shift &bull; {{ shift.presenter.carer.name }} &bull; {{ shift.presenter.team?.name }}
    </app-dialog-subtitle>
</app-dialog-header>


<mat-dialog-content *ngIf="shift">
    <cll-panel colour="success"
               data-testid="info:shift-attended"
               style="margin-bottom: 16px;"
               *ngIf="shift.attended">
        <cll-icon cllPanelIcon>check_circle</cll-icon>
        This shift has been attended
    </cll-panel>

    <cll-panel colour="info"
               data-testid="info:shift-attended"
               style="margin-bottom: 16px;"
               *ngIf="ui.changed.attended">
        <cll-icon cllPanelIcon>info</cll-icon>
        Save shift to confirm it has been attended
        <button cll-button
                type="button"
                cllPanelAction
                (click)="updateAttended(false)"
                [disabled]="state.fetching">
            Mark as unattended
        </button>
    </cll-panel>

    <cll-panel colour="warning" *ngIf="!(shift.attended || shiftCopy.attended) && shift.presenter.hasStarted" style="margin-bottom: 16px;">
        <cll-icon cllPanelIcon>timer</cll-icon>

        Shift has {{ shift.presenter.hasFinished ? 'finished' : 'started'}}, do you want
        to mark as attended?

        <button cll-button
                type="button"
                data-testid="button:mark-as-attended"
                cllPanelAction
                (click)="updateAttended(true)"
                [disabled]="state.fetching">
            Mark as attended
        </button>
    </cll-panel>

    <app-input-when
        [(ngModel)]="shiftCopy"
        (ngModelChange)="onChange()"
        [disabled]="ui.saving || shift.presenter.cannotUpdateTime" />

    <hr class="app-separator">

    <app-input-textarea
        label="Carer Notes"
        [(ngModel)]="shiftCopy.carer_notes"
        (ngModelChange)="onChange()"
        [readonly]="!shift.presenter.canUpdateCarerNotes"
        [disabled]="ui.saving"
        [hint]="shift.presenter.carerNotesHint" />

    <app-input-textarea
        label="Notes"
        [(ngModel)]="shiftCopy.notes"
        (ngModelChange)="onChange()"
        [readonly]="false"
        [disabled]="ui.saving"
        hint="Not visible to carer" />

</mat-dialog-content>

<mat-dialog-actions>

    <button cll-button
            colour="secondary"
            (click)="dialogRef.close()">
        Cancel
    </button>

    <a cll-tonal-button
        colour="secondary"
       [href]="'/shifts/' + shift.id"
       target="_blank">
        View
    </a>

    <button cll-filled-button
            colour="secondary"
            data-testid="button:save-shift-attendance"
            [disabled]="ui.saving || !ui.hasChanged"
            (click)="save()">
        Save
    </button>
</mat-dialog-actions>
